// Utilidades para el selector de mes de los "Datos parciales".
// Filtramos por mes natural del año en curso, mostrando sólo hasta el mes actual.

export const MESES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

// Lista de meses seleccionables: del año en curso, de Enero hasta el mes actual (incluido).
export const mesesHastaActual = () => {
    const now = new Date();
    const year = now.getFullYear();
    const mesActual = now.getMonth(); // 0-11
    const opciones = [];
    for (let m = 0; m <= mesActual; m++) {
        opciones.push({ value: m, year, label: MESES[m] });
    }
    return opciones;
};

// Rango YYYY-MM-DD del mes natural completo (primer y último día).
export const rangoMes = (year, monthIndex) => {
    const pad = (n) => String(n).padStart(2, "0");
    const lastDay = new Date(year, monthIndex + 1, 0).getDate();
    return {
        from: `${year}-${pad(monthIndex + 1)}-01`,
        to: `${year}-${pad(monthIndex + 1)}-${pad(lastDay)}`,
    };
};
